import api from "utils/API";

// El backend cappea page_size a un maximo fijo por endpoint (25 para los
// listados de tareaspaciente) sin importar el valor pedido, y sin params de
// pagina devuelve solo esa primera pagina como arreglo plano (sin
// count/next). Para pantallas que necesitan el listado completo hay que
// pedir pagina por pagina hasta que una respuesta traiga menos filas que
// pageSize.
export const fetchAllPages = (baseUrl, extraParams = {}, pageSize = 25) => {
  const fetchPage = (page, accRows) => {
    const params = new URLSearchParams({
      ...extraParams,
      page: String(page),
      page_size: String(pageSize),
    });
    return api.get(`${baseUrl}?${params.toString()}`).then((response) => {
      const rows = response.data;
      const allRows = accRows.concat(rows);
      if (rows.length < pageSize) {
        return allRows;
      }
      return fetchPage(page + 1, allRows);
    });
  };

  return fetchPage(1, []);
};
